import { Trans, useTranslation } from 'react-i18next';

import {
    Anchor,
    Body1,
    Button,
    Heading1,
    List,
    ListItem,
    Stack,
} from '@myphx-engineering/phx-design-system';
import type { ConsentInfoScreenProps } from '@phx/consents/client';

type BodyListItem = {
    description: string;
};

export const ConsentInfoScreen = ({
    onContinue,
    onDeclineAll,
    loading,
}: ConsentInfoScreenProps) => {
    const { t } = useTranslation();
    const listItems: BodyListItem[] = t<
        string,
        { returnObjects: true },
        BodyListItem[]
    >('consents.infoScreen.body.listItems', {
        returnObjects: true,
    });

    return (
        <Stack gap="lg">
            <Stack gap="md">
                <Heading1>{t('consents.infoScreen.title')}</Heading1>
                <Body1>{t('consents.infoScreen.body.intro')}</Body1>
            </Stack>

            <Stack gap="xs">
                <Body1>{t('consents.infoScreen.body.description')}</Body1>

                <List>
                    {listItems.map((item, index) => (
                        <ListItem key={index}>
                            <Body1>
                                <Trans
                                    ns="dynamic"
                                    i18nKey={item.description}
                                    components={{
                                        1: <strong />,
                                        2: (
                                            <Anchor
                                                href="https://www.lilly.com/"
                                                textDecoration="none"
                                                target="_blank"
                                            />
                                        ),
                                    }}
                                />
                            </Body1>
                        </ListItem>
                    ))}
                </List>

                <Body1>{t('consents.infoScreen.body.footer')}</Body1>
            </Stack>

            <Stack gap="xxs">
                <Button onClick={onContinue} size="lg" loading={loading}>
                    {t('consents.infoScreen.actions.continue')}
                </Button>
                <Button
                    variant="subtle"
                    size="lg"
                    onClick={onDeclineAll}
                    loading={loading}
                >
                    {t('consents.infoScreen.actions.decline')}
                </Button>
            </Stack>
        </Stack>
    );
};
